/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Archival_Set_WinnerInputs */



/**
* | output |
* | --- |
* | "Mark as winner" |
*
* @param {Archival_Set_WinnerInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const archival_set_winner = /** @type {((inputs?: Archival_Set_WinnerInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Archival_Set_WinnerInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Désigner comme vainqueur")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcar como ganador")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Marcar como vencedor")
	if (locale === "it") return /** @type {LocalizedString} */ ("Segna come vincitore")
	return /** @type {LocalizedString} */ ("Mark as winner")
});